import type { FunctionComponent, PropsWithChildren } from 'react';

import * as styles from './BoardTileDropdownWrapper.module.less';

interface BoardTileDropdownWrapperProps {
  dataTestId?: string;
}

export const BoardTileDropdownWrapper: FunctionComponent<
  PropsWithChildren<BoardTileDropdownWrapperProps>
> = ({ dataTestId, children }) => {
  return (
    <ul
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
      role="menu"
      data-testid={dataTestId}
      className={styles.boardTileDropDownWrapper}
    >
      {children}
    </ul>
  );
};
